import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { customerApi } from '../api/customerApi';

interface AllowAccessParams {
  customerId: string;
  profileId: string;
  numberOfAccessDays: number;
  reason: string;
}

export const useAllowAccess = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(
    (_: any, variables: { customerId: string }) => {
      queryClient.invalidateQueries({
        queryKey: ['access-allowed', variables.customerId],
      });
    },
    [queryClient]
  );

  const { mutate: allowAccess } = useMutation({
    mutationFn: ({
      customerId,
      profileId,
      numberOfAccessDays,
      reason,
    }: AllowAccessParams) =>
      customerApi.allowAccess(
        customerId,
        profileId,
        numberOfAccessDays,
        reason
      ),
    onSuccess,
  });

  return { allowAccess };
};
